import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '@shared/components';
import { WorkstationFacade } from '@app/store/workstation';

@Component({
    selector: 'app-workstation-indicator',
    templateUrl: './workstation-indicator.component.html',
    styleUrls: ['./workstation-indicator.component.css'],

    imports: [RouterLink, IconComponent, TranslatePipe],
})
export class WorkstationIndicatorComponent {
    private readonly workstationFacade = inject(WorkstationFacade);

    protected readonly workstationCode = this.workstationFacade.workstationCode;

    protected readonly hasPrinterWarning = computed(() => (this.workstationFacade.workstation()?.printerWarnings.length ?? 0) > 0);
}
